import { parseCatalogChannelBase } from '@wix/wix-vod-api/dist/src/parsers/catalog-channel';

export const parseCatalogChannel = parseCatalogChannelBase;
